const VideoQueryKeys = {
  global: ["videos"] as const,
  video: (statusId: string) => [...VideoQueryKeys.global, statusId] as const,
};

export { VideoQueryKeys };
